export const initSearchDoubleSlider = () => {
  const doubleSliderContainers: NodeListOf<HTMLDivElement> = document.querySelectorAll(
    ".double-slider-container",
  );

  if (!doubleSliderContainers) {
    return;
  }

  doubleSliderContainers.forEach((doubleSliderContainer) => {
    const sliderOne = doubleSliderContainer.querySelector(".slider-1") as HTMLInputElement;
    const sliderTwo = doubleSliderContainer.querySelector(".slider-2") as HTMLInputElement;
    const minGap = 0;
    const sliderTrack = doubleSliderContainer.querySelector(".slider-track") as HTMLDivElement;
    const sliderMinValue = parseInt(sliderOne.min, 10);
    const sliderMaxValue = parseInt(sliderOne.max, 10);

    slideOne();
    slideTwo();

    sliderOne.addEventListener("input", () => {
      slideOne();
    });
    sliderTwo.addEventListener("input", () => {
      slideTwo();
    });

    // Native slider dragging captures the whole gesture to whichever handle is on top when the
    // drag starts, so when both handles sit on the same value, only one of the two directions is
    // ever reachable (the buried handle never receives the drag). Take dragging over manually in
    // that case: figure out which handle the user means to move from where the drag goes, and
    // drive that handle's value directly for the rest of the gesture.
    sliderOne.addEventListener("pointerdown", onCoincidentPointerDown);
    sliderTwo.addEventListener("pointerdown", onCoincidentPointerDown);

    function onCoincidentPointerDown(event: PointerEvent) {
      if (parseInt(sliderOne.value, 10) !== parseInt(sliderTwo.value, 10)) {
        return;
      }

      event.preventDefault();
      (event.currentTarget as HTMLInputElement).focus();

      const startValue = parseInt(sliderOne.value, 10);
      let draggedSlider: "one" | "two" | null = null;

      const onPointerMove = (moveEvent: PointerEvent) => {
        const value = valueFromClientX(moveEvent.clientX);

        if (draggedSlider === null) {
          if (value === startValue) {
            return;
          }

          draggedSlider = value < startValue ? "one" : "two";
        }

        setSliderValue(draggedSlider === "one" ? sliderOne : sliderTwo, value);
      };

      const onPointerUp = () => {
        document.removeEventListener("pointermove", onPointerMove);
        document.removeEventListener("pointerup", onPointerUp);
      };

      document.addEventListener("pointermove", onPointerMove);
      document.addEventListener("pointerup", onPointerUp);
    }

    function valueFromClientX(clientX: number) {
      const trackRect = sliderTrack.getBoundingClientRect();
      const ratio = Math.min(Math.max((clientX - trackRect.left) / trackRect.width, 0), 1);

      return Math.round(sliderMinValue + ratio * (sliderMaxValue - sliderMinValue));
    }

    function setSliderValue(slider: HTMLInputElement, value: number) {
      slider.value = value.toString();
      slider.dispatchEvent(new Event("input", { bubbles: true }));
    }

    function slideOne() {
      if (parseInt(sliderTwo.value, 10) - parseInt(sliderOne.value, 10) <= minGap) {
        const sliderOneValue = parseInt(sliderTwo.value, 10) - minGap;
        sliderOne.value = sliderOneValue.toString();
      }

      fillColor();
    }

    function slideTwo() {
      if (parseInt(sliderTwo.value, 10) - parseInt(sliderOne.value, 10) <= minGap) {
        const sliderTwoValue = parseInt(sliderOne.value, 10) + minGap;
        sliderTwo.value = sliderTwoValue.toString();
      }

      fillColor();
    }

    function fillColor() {
      const percent1 =
        ((parseInt(sliderOne.value, 10) - sliderMinValue) / (sliderMaxValue - sliderMinValue)) *
        100;
      const percent2 =
        ((parseInt(sliderTwo.value, 10) - sliderMinValue) / (sliderMaxValue - sliderMinValue)) *
        100;
      sliderTrack.style.background = `linear-gradient(to right, var(--bs-gray-300) ${percent1}% , var(--bs-primary) ${percent1}% , var(--bs-primary) ${percent2}%, var(--bs-gray-300) ${percent2}%)`;
    }
  });
};
